import { RollbackOutlined, SaveOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, InputNumber, Select, Spin } from 'antd'
import { FormInstance } from 'antd/lib/form'
import React, { RefObject } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirebase, withFirestore } from 'react-redux-firebase'
import { withHandlers } from 'recompose'
import { compose } from 'redux'

import { withRouter } from 'react-router-dom'
import { SHOW_NOTIFICATION } from '../../constants/ActionTypes'
import { ERROR, SUCCESS } from '../../constants/notifications'
import {
  findInOrdered,
  fsCollections,
  makeInBatchWithFirebase,
  withoutUndefined,
} from '../../helpers/firestore'
import { languages } from '../../shared/languages'
import authorize from '../higher-order/authorize'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
}

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
}

class CategoryForm extends React.Component<any, any> {
  formRef: RefObject<FormInstance<any>> = React.createRef()

  handleSubmit = (values) => {
    const { onSubmit } = this.props
    onSubmit(withoutUndefined(values))
  }

  handleFailure = ({ errorFields }) => {
    this.formRef?.current?.scrollToField(errorFields[0].name)
    /* TODO display somewhere */
    // tslint:disable-next-line:no-console
    console.log('Error during validation', errorFields)
  }

  render() {
    const { categoryId, category, previousLocation, goToPreviousLocation } = this.props
    const { getFieldValue } = this.formRef.current
      ? this.formRef.current
      : { getFieldValue: () => undefined }

    const currentMaxAge = getFieldValue('maxAge')
    const currentMinAge = getFieldValue('minAge')

    const minAgeAdditionalParams = currentMaxAge ? { max: currentMaxAge - 1 } : {}
    const maxAgeAdditionalParams = currentMinAge ? { min: currentMinAge + 1 } : {}

    const form = (
      <Form
        ref={this.formRef}
        onFinish={this.handleSubmit}
        onFinishFailed={this.handleFailure}
        initialValues={category}>
        {languages.map((language) => (
          <Form.Item
            key={language}
            {...formItemLayout}
            label="Name"
            hasFeedback
            name={`name:${language}`}
            rules={[{ required: true, message: 'Please input name!' }]}>
            <Input addonBefore={language} />
          </Form.Item>
        ))}
        <Form.Item {...formItemLayout} label="Level Filter" hasFeedback name="level">
          <Select allowClear>
            <Select.Option value="Novices">Novices</Select.Option>
            <Select.Option value="Other">Other</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="Gender Filter" hasFeedback name="gender">
          <Select allowClear>
            <Select.Option value="Female">Female</Select.Option>
            <Select.Option value="Male">Male</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...formItemLayout} label="Age Filter">
          <Col span={12}>
            <Form.Item hasFeedback name="minAge">
              <InputNumber
                style={{ width: '10em' }}
                placeholder="Minimum"
                min={1}
                {...minAgeAdditionalParams}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item hasFeedback name="maxAge">
              <InputNumber
                style={{ width: '10em' }}
                placeholder="Maximum"
                {...maxAgeAdditionalParams}
              />
            </Form.Item>
          </Col>
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button.Group>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Submit
            </Button>
            {previousLocation ? (
              <Button danger onClick={goToPreviousLocation} icon={<RollbackOutlined />}>
                Cancel
              </Button>
            ) : null}
          </Button.Group>
        </Form.Item>
      </Form>
    )

    return categoryId && !isLoaded(category) ? <Spin>{form}</Spin> : form
  }
}

export default compose<FIXME>(
  authorize('admin'),
  withFirebase,
  withFirestore,
  withRouter,
  firestoreConnect<FIXME>(({ tenant }) => [{ collection: fsCollections.globalCategories(tenant) }]),
  connect(({ firestore }: FIXME, { tenant, categoryId }: FIXME) => ({
    category: findInOrdered(firestore.ordered[fsCollections.globalCategories(tenant)], categoryId),
  })),
  withHandlers<any, any>({
    goToPreviousLocation: ({ history, previousLocation }) => () => {
      if (previousLocation) {
        history.push(previousLocation)
      }
    },
    inBatchBound: makeInBatchWithFirebase,
  }),
  withHandlers({
    upsertSuccess: ({ dispatch, goToPreviousLocation }) => () => {
      dispatch({ type: SHOW_NOTIFICATION, message: 'Category saved', kind: SUCCESS })
      goToPreviousLocation()
    },
    upsertError: ({ dispatch }) => (err) => {
      // tslint:disable-next-line:no-console
      console.error('Failed to save category', err)
      dispatch({ type: SHOW_NOTIFICATION, message: 'Failed to save category', kind: ERROR })
    },
    upsertCategory: ({ inBatchBound, tenant, categoryId }) => (category) =>
      inBatchBound((firestore, batch) => {
        const collection = firestore.collection(fsCollections.globalCategories(tenant))
        const categoryReference = categoryId ? collection.doc(categoryId) : collection.doc()

        batch.set(categoryReference, category)
      }),
  }),
  withHandlers({
    onSubmit: ({ upsertCategory, upsertError, upsertSuccess }) => (category) =>
      upsertCategory(category)
        .then((res) => upsertSuccess(res))
        .catch((err) => upsertError(err)),
  }),
)(CategoryForm)



// WEBPACK FOOTER //
// ./src/components/categories/CategoryForm.tsx